import * as helpers from '../helpers';

const $ = helpers.$;

export default class ToTopButton {
	constructor($element, options) {
		this.$element = $element;
		this.visibleClass = options.visibleClass;
		this.handleClick();
		this.handleScroll();
	}

	handleClick() {
		this.$element.click(e => {
			e.preventDefault();
			helpers.executeScroll(0.01, 1000);
		});
	}

	handleScroll() {
		const $button = this.$element,
			visibleClass = this.visibleClass;

		$(document).scroll(function() {
			if ($(this).scrollTop() > 300) {
				$button.addClass(visibleClass);
			} else {
				$button.removeClass(visibleClass);
			}
			
		});
	}
}


// WEBPACK FOOTER //
// ./assets/js/src/components/ToTopButton.js